import type { StoreHit } from '@/lib/algolia';
import type {
  RepairDeliveryMethod,
  RepairReturnMethod,
  RepairShippingKitOption,
} from '@/lib/service/ecs/logisticsCapabilities';
import type { WatchProductSummary } from '@/lib/service/ecs/contracts';
import type { Watch } from '@/lib/myWatches/types';

export type RepairRequestStep = 'watch' | 'personal' | 'review';

export interface RepairRequestStoredAddress {
  title?: string | null;
  firstName: string;
  lastName: string;
  companyName?: string;
  streetAddress1: string;
  streetAddress2?: string;
  city: string;
  postalCode: string;
  country: string;
  countryArea?: string;
  phone?: string;
}

export interface RepairRequestReason {
  label: string;
  value: string;
}

export interface RepairRequestState {
  reasons: RepairRequestReason[];
  reasonComment: string;
  serialNumber: string | null;
  referenceNumber: string | null;
  watchWarranty: Watch | null;
  watchProductSummary: WatchProductSummary | null;
  deliveryMethod: RepairDeliveryMethod | null;
  returnMethod: RepairReturnMethod | null;
  shippingKitOption: RepairShippingKitOption | null;
  serviceBoutique: StoreHit | null;
  shippingAddress: RepairRequestStoredAddress | null;
  billingAddress: RepairRequestStoredAddress | null;
  differentBillingAddress: boolean;
  email: string;
  phone: string;
  phonePrefixCode: string;
}

export const REPAIR_REQUEST_INITIAL_STATE: RepairRequestState = {
  reasons: [],
  reasonComment: '',
  serialNumber: null,
  referenceNumber: null,
  watchWarranty: null,
  watchProductSummary: null,
  deliveryMethod: null,
  returnMethod: null,
  shippingKitOption: null,
  serviceBoutique: null,
  shippingAddress: null,
  billingAddress: null,
  differentBillingAddress: false,
  email: '',
  phone: '',
  phonePrefixCode: '',
};

export const REPAIR_REQUEST_STEP_ROUTES: Record<RepairRequestStep, string> = {
  watch: '/service/request/watch',
  personal: '/service/request/personal',
  review: '/service/request/review',
};

export function repairRequestStepFromPathname(
  pathname: string | null | undefined
): RepairRequestStep {
  if (pathname?.includes('/personal')) return 'personal';
  if (pathname?.includes('/review')) return 'review';
  return 'watch';
}

export function isRegisteredWatch(watch: Watch | null | undefined): boolean {
  return watch?.is_bind === true;
}
